import React, { createContext, useContext } from "react";
import { useDeliveryEDBLogic } from "../hooks/useDeliveryEDBLogic";

export const DeliveryEDBContext = createContext<any | undefined>(undefined);

export const useDeliveryEDBContext = () => {
  const context = useContext(DeliveryEDBContext);
  if (context === undefined) {
    throw new Error(
      "useDeliveryEDBContext must be used within an DeliveryEDBProvider"
    );
  }
  return context;
};

interface DeliveryEDBContextProps {
  children: React.ReactNode;
  edbCompanyId: string | null;
}

export const DeliveryEDBProvider = ({
  children,
  edbCompanyId,
}: DeliveryEDBContextProps) => {
  const value = useDeliveryEDBLogic({ edbCompanyId });

  return (
    <DeliveryEDBContext.Provider value={value}>
      {children}
    </DeliveryEDBContext.Provider>
  );
};
